/** @jsxImportSource @emotion/react */
'use client'

import Typography from '@mui/material/Typography'
import { FlexCol, FlexRow } from '../layout'
import StatCardShell from './StatCardShell'
import { styles } from './styles'

/**
 * Headline volume stat — 6,000 unique AI requests completed since BIBA.
 * Uses the `dark` tone as the anchor slide of the carousel.
 */
export default function RequestsStatCard() {
  return (
    <StatCardShell
      kicker="Since BIBA"
      tone="dark"
      footer={
        <FlexRow gap="lg" wrap>
          <FlexCol gap="xs">
            <Typography
              component="span"
              css={[styles.subValue, styles.headingFont]}
            >
              ~128
            </Typography>
            <Typography component="span" css={styles.subLabel}>
              requests / day
            </Typography>
          </FlexCol>
          <FlexCol gap="xs">
            <Typography
              component="span"
              css={[styles.subValue, styles.headingFont]}
            >
              100%
            </Typography>
            <Typography component="span" css={styles.subLabel}>
              outputs logged
            </Typography>
          </FlexCol>
        </FlexRow>
      }
    >
      <FlexCol gap="sm">
        <Typography component="p" css={[styles.metric, styles.headingFont]}>
          6,000
        </Typography>
        <Typography
          component="p"
          css={[styles.metricLabel, styles.descriptionTone.dark]}
        >
          unique AI requests completed for our partners
        </Typography>
      </FlexCol>
    </StatCardShell>
  )
}
